import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import API_URL from "../../config/ApiUrl";
import axios from "axios";

export const getForms = createAsyncThunk(
    "Forms/get",
    async (payload, { rejectWithValue, dispatch }) => {
        try {
            dispatch(setActivePayload(payload));
            const filteredPayload = Object.fromEntries(
                Object.entries(payload).filter(
                    ([, value]) => value !== null && value !== undefined && value !== ""
                )
            );
            const params = new URLSearchParams();

            for (const [key, value] of Object.entries(filteredPayload)) {
                if (Array.isArray(value)) {
                    value.forEach((item) => {
                        params.append(key, item);
                    });
                } else {
                    params.append(key, value);
                }
            }
            const queryString = params.toString();

            const { data } = await axios.get(`${API_URL.VERIFICATION.GET_FORMS}?${queryString}`);
            return data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const createForm = createAsyncThunk(
    "Form/create",
    async (payload, { rejectWithValue, dispatch, getState }) => {
        try {
            const { data } = await axios.post(`${API_URL.VERIFICATION.GET_FORMS}`, payload);
            const { active_payload } = getState().form;
            dispatch(getForms(active_payload));
            return data.data;
        } catch (error) {
            return rejectWithValue(error.data);
        }
    }
);

export const deleteForm = createAsyncThunk(
    "Form/delete",
    async (id, { rejectWithValue, dispatch, getState }) => {
        try {
            const { data } = await axios.delete(`${API_URL.VERIFICATION.GET_FORMS}/${id}`);
            const { active_payload } = getState().form;
            dispatch(getForms(active_payload));
            return data.data;
        } catch (error) {
            return rejectWithValue(error.data);
        }
    }
);

export const editForm = createAsyncThunk(
    "Form/put",
    async (payload, { rejectWithValue, dispatch, getState }) => {
        try {
            const { data } = await axios.put(`${API_URL.VERIFICATION.GET_FORMS}`, payload);
            const { active_payload } = getState().form;
            dispatch(getForms(active_payload));
            return data.data;
        } catch (error) {
            return rejectWithValue(error.data);
        }
    }
);

export const getFormsForPicker = createAsyncThunk(
    "Form/pickerList",
    async (searchText, { rejectWithValue }) => {
        try {
            const params = new URLSearchParams({ PageSize: "500", PageNumber: "1" });
            if (searchText) params.append("SearchText", searchText);
            const { data } = await axios.get(`${API_URL.VERIFICATION.GET_FORMS}?${params.toString()}`);
            return data?.data?.list ?? [];
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const getFormChildren = createAsyncThunk(
    "Form/getChildren",
    async (parentId, { rejectWithValue }) => {
        try {
            const { data } = await axios.get(`${API_URL.VERIFICATION.GET_FORMS}/${parentId}/Children`);
            return data?.data ?? [];
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const saveFormChildren = createAsyncThunk(
    "Form/saveChildren",
    async ({ parentId, childFormIds }, { rejectWithValue }) => {
        try {
            const { data } = await axios.post(`${API_URL.VERIFICATION.GET_FORMS}/${parentId}/Children`, { childFormIds });
            return data.data;
        } catch (error) {
            return rejectWithValue(error.data);
        }
    }
);

const formSlice = createSlice({
    name: "form",
    initialState: {
        form_list: [],
        current_values: null,
        active_payload: null,
    },
    reducers: {
        setCurrentValues(state, action) {
            state.current_values = action.payload;
        },
        setActivePayload(state, action) {
            state.active_payload = action.payload;
        },
        resetCurrentValue(state) {
            state.current_values = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getForms.fulfilled, (state, action) => {
            state.form_list = action.payload.data.list;
        });
    },
});
export const { setCurrentValues, setActivePayload, resetCurrentValue } =
    formSlice.actions;
export default formSlice.reducer;
